import {SegmentModel} from '../../segment.model';

export class SegmentValidationModel {
  id?: number;
  positiveExample!: SegmentModel;
  totalPopulation!: SegmentModel;
  name!: string;

  constructor(fields: { positiveExample: SegmentModel, totalPopulation: SegmentModel, name: string, id?: number }) {
    if (fields) {
      Object.assign(this, fields);
    }
  }

  static fromList(segmentValidationsObject: any[]): SegmentValidationModel[] {
    return segmentValidationsObject.map((item) => {
      return SegmentValidationModel.from(item);
    });
  }

  static from(segmentValidationObject: any): SegmentValidationModel {
    return new SegmentValidationModel({
      id: segmentValidationObject.id,
      positiveExample: new SegmentModel(segmentValidationObject.positiveExample),
      totalPopulation: new SegmentModel(segmentValidationObject.totalPopulation),
      name: segmentValidationObject.name
    });
  }


}
